export const seoConfig = {
  siteName: 'Coupling WNC',
  siteUrl: 'https://couplingwnc.com',
  defaultDescription:
    'Checkout, appointments, and rewards for Western North Carolina merchants. Tap to Pay on the phone you already have. Coupling POS runs your entire checkout. Mix cash, card, and rewards.',
  defaultOgImage: 'https://couplingwnc.com/og-image.png',
};
